import apiClient from "@/shared/api/apiClient4";

export const getServiceList = async (params) => {
  try {
    const { data } = await apiClient.get("/services/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getServiceList failed", e);
  }
};

export const getServiceListWithResponse = async (params) => {
  try {
    const { data } = await apiClient.get("/step-runs/fetcher-schema/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getServiceListWithResponse failed", e);
  }
};

export const getServiceListWithResponseByCode = async (service_code) => {
  try {
    const { data } = await apiClient.get(
      "/step-runs/fetcher-schema/" + service_code
    );
    return data;
  } catch (e) {
    console.error("getServiceListWithResponseByCode failed", e);
  }
};

export const runChainService = async (
  execution_uuid,
  step_run_uuid,
  tx_id,
  params
) => {
  try {
    const { data } = await apiClient.post(
      `/step-runs/run-service/${execution_uuid}/${step_run_uuid}/${tx_id}/v2`,
      {
        ...params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("runChainService failed", e);
    throw e;
  }
};
